module.exports = __webpack_public_path__ + "static/media/logo.7b7862c5.png";